import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Table component with consistent styling
 */
const Table = React.forwardRef(({
    className,
    ...props
}, ref) => (
    <div className="table-modern">
        <table
            ref={ref}
            className={cn(
                'min-w-full divide-y divide-gray-200',
                className
            )}
            {...props}
        />
    </div>
));

Table.displayName = 'Table';

/**
 * TableHeader component
 */
const TableHeader = React.forwardRef(({
    className,
    ...props
}, ref) => (
    <thead
        ref={ref}
        className={cn(
            'bg-gray-50',
            className
        )}
        {...props}
    />
));

TableHeader.displayName = 'TableHeader';

/**
 * TableBody component
 */
const TableBody = React.forwardRef(({
    className,
    ...props
}, ref) => (
    <tbody
        ref={ref}
        className={cn(
            'bg-white divide-y divide-gray-200',
            className
        )}
        {...props}
    />
));

TableBody.displayName = 'TableBody';

/**
 * TableRow component
 */
const TableRow = React.forwardRef(({
    className,
    ...props
}, ref) => (
    <tr
        ref={ref}
        className={cn(
            'hover:bg-gray-50 transition-colors duration-150',
            className
        )}
        {...props}
    />
));

TableRow.displayName = 'TableRow';

/**
 * TableHead component
 */
const TableHead = React.forwardRef(({
    className,
    ...props
}, ref) => (
    <th
        ref={ref}
        className={cn(
            'table-modern th',
            className
        )}
        {...props}
    />
));

TableHead.displayName = 'TableHead';

/**
 * TableCell component
 */
const TableCell = React.forwardRef(({
    className,
    ...props
}, ref) => (
    <td
        ref={ref}
        className={cn(
            'table-modern td',
            className
        )}
        {...props}
    />
));

TableCell.displayName = 'TableCell';

export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell };